import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import clsx from 'clsx';
import { MuiThemeProvider } from "@material-ui/core/styles";
import {muiTheme} from '../styling/Styles';

const CreateDataElementSnackBar = (props) => {

    const {
        open,
        setOpen,
        isEdit,
        editElement
    } = props;

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setOpen(false);
      };

    const returnMessage = () => {
        if(isEdit === false && editElement !== true){
            return "Generated data element wrapper and data element block";
        }
        if(isEdit === true && editElement !== true){
            return "Edited data element wrapper and data element block";
        }
        return "New data element block has created";
    }

    return (
        <MuiThemeProvider theme={muiTheme}>
            <Snackbar
            anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
            }}
            open={open}
            autoHideDuration={3000}
            onClose={handleClose}
            message= { returnMessage()}
            action={
                <i className={clsx('fas', 'fa-times-circle', 'teamSelector')} aria-hidden="true" onClick={handleClose}/>
            }
            
            />
        </MuiThemeProvider>
    )
}

export default CreateDataElementSnackBar;
